<script lang="ts">
  import { t } from 'svelte-i18n-lingui';
  import type { LocationMapComponent } from "$lib/js/strapi/types";

  export let component: LocationMapComponent
</script>


{#if component.display === true}
  <div class="location-map">
    <h2>{$t`Our offices are located in Barcelona`}</h2>
    <iframe
      title="Location map"
      style="border: 0;"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2993.249334713971!2d2.1743523515664025!3d41.39039127916208!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDHCsDIzJzI1LjQiTiAywrAxMCczNS42IkU!5e0!3m2!1ses!2ses!4v1626795827735!5m2!1ses!2ses"
      width="100%"
      height="600"
      allowfullscreen
    >
    </iframe>
  </div>
{/if}


<style lang="scss">
  .location-map {
    margin: 30px 0;

    h2 {
      margin-bottom: 25px;
    }
  }
</style>
